// extracted by mini-css-extract-plugin
export default {"title":"HccJh","summary":"nZbml","disclaimer":"TD6K4","sectionContainer":"nEhVO","maxWidthContainer":"SG_r9","wrapper":"ZVC4u","disclaimerWrapper":"DJAB6","disclaimerIcon":"dmS_G"};